import { Component, DestroyRef, inject, computed } from '@angular/core';
import { Account, AccountManagementColumn } from '../types';
import { ClientSideRowModelModule, GridOptions, RowClickedEvent, themeQuartz, type ColDef, SortChangedEvent } from "ag-grid-community";
import { MatDialog } from '@angular/material/dialog';
import { AgGridAngular } from 'ag-grid-angular';
import { AgTooltipCellComponent } from '../../../shared/components/ag-tooltip-cell/ag-tooltip-cell.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { StateService } from '../../../services/state.service';
import { ManagementService } from '../management.service';
import { UtilService } from '../../../services/util.service';
import { AccountModalComponent } from '../account-modal/account-modal.component';
import {getManagementDateFormat} from '../../../utils/time';

@Component({
  selector: 'app-accounts-table',
  imports: [AgGridAngular],
  templateUrl: './accounts-table.component.html',
  styleUrl: './accounts-table.component.scss'
})
export class AccountsTableComponent {

  public data = computed(() => this.managementService.tableData() as Account[]);
  colDefs: ColDef[] = this.getColDef();
  theme = themeQuartz.withParams({
    spacing: 10,
    headerBackgroundColor: 'rgba(217, 217, 217, 0.3)',
    rowHoverColor: 'rgba(233, 244, 245, 0.85)',
    fontSize: '14px',
    headerFontSize: '16px',
    fontFamily: 'Poppins',
    headerFontFamily: 'Poppins',
    headerFontWeight: 600,
    headerTextColor: '#717172;',
    cellTextColor: '#717172;',
    headerHeight: 64,
  });
  modules = [ClientSideRowModelModule];
  gridOptions: GridOptions = {
    suppressMovableColumns: true,
    domLayout: 'autoHeight',
    rowHeight: undefined,
    defaultColDef: {
      resizable: false,
      autoHeight: true,
      sortable: true,
      wrapText: true,
      flex: 1
    },
  };
  private destroyRef = inject(DestroyRef);

  constructor(private dialog: MatDialog, private stateService: StateService,
    private managementService: ManagementService, private utilService: UtilService) { }

  public onRowClicked = (event: RowClickedEvent) => {
    const dialogRef = this.dialog.open(AccountModalComponent, {
      data: {
        ...event.data
      },
      panelClass: 'management-modal',
      autoFocus: false
    });
    dialogRef.afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((result: Account) => {
      if (result) {
        const currentData = this.data();
        const index = currentData.findIndex(account => account.name === result.name);
        if (index !== -1) {
          const updatedTableData = [...currentData];
          updatedTableData[index] = result;
          this.managementService.tableData.set(updatedTableData);
          this.utilService.openSnackBar(`Account "${result.name}" updated successfuly`, { position: 'center', variant: 'success' });
        }
      }
      this.stateService.loading = false;
    });
  };


  public onSortChanged(event: SortChangedEvent) {
    const sortModel = event.columns?.[0]
    this.managementService.sortState.set({
      sortBy: sortModel?.getColId()|| '',
      sortDir: sortModel?.getSort() || 'desc'
    });
    this.managementService.refreshTable$.next();
  }

  private getColDef() {
    return [
      {
        field: AccountManagementColumn.NAME,
      },
      {
        field: 'Users',
        cellRenderer: AgTooltipCellComponent,
        valueGetter: (params: any) => {
          return params.data?.[AccountManagementColumn.USERS].length;
        },
        sortable: false
      },
      {
        field: AccountManagementColumn.BRANDS,
        cellRenderer: AgTooltipCellComponent,
        valueGetter: (params: any) => {
          return params.data[AccountManagementColumn.BRANDS].length
        },
        sortable: false
      },
      {
        field: AccountManagementColumn.CREATED_AT,
        valueGetter: (params: any) => {
          return getManagementDateFormat(params.data[AccountManagementColumn.CREATED_AT])
        }
      },
    ];
  }
}
